import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  updateHighlightingRules,
  addHighlightingRule,
  updateHighlightingRule,
  removeHighlightingRule
} from "views/logic/slices/highlightActions";
import HighlightingRules from "views/components/sidebar/highlighting/HighlightingRules";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useProductName from "brand-customization/useProductName";
const ViewsHighlightingRules = () => {
  const dispatch = useViewsDispatch();
  const productName = useProductName();
  const { t } = useTranslation("search");
  const onUpdateRules = useCallback(
    (newRules) => dispatch(updateHighlightingRules(newRules)).then(() => {
    }),
    [dispatch]
  );
  const onCreateRule = useCallback(
    (newRule) => dispatch(addHighlightingRule(newRule)).then(() => {
    }),
    [dispatch]
  );
  const onUpdateRule = useCallback(
    (targetRule, field, value, condition, color) => dispatch(updateHighlightingRule(targetRule, { field, value, condition, color })).then(() => {
    }),
    [dispatch]
  );
  const onDeleteRule = useCallback(
    (rule) => dispatch(removeHighlightingRule(rule)).then(() => {
    }),
    [dispatch]
  );
  const description = t("sidebar_highlighting.description", { productName });
  return /* @__PURE__ */ React.createElement(
    HighlightingRules,
    {
      description,
      onDeleteRule,
      onUpdateRules,
      onCreateRule,
      onUpdateRule
    }
  );
};
export default ViewsHighlightingRules;
